import { useEffect, useState } from "react";
import MainLayout from "../components/layouts/MainLayout";
import { providerApi } from "../api/providerApi";
import { ClientApi } from "../api/clientApi";
import Swal from "sweetalert2";
import { Auth } from "../utils/Auth";
import { useNavigate } from "react-router-dom";
import { annonceApi } from "../api/annonceApi";
import { CommandeApi } from "../api/commandeApi";
import { AbonnementApi } from "../api/abonnementApi";
import { Chart as ChartJS, 
  ArcElement, 
  Tooltip, 
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title, } from 'chart.js';
import { Pie, Line } from 'react-chartjs-2';
import { faker } from "@faker-js/faker";
import { AdminApi } from "../api/adminsApi";
import { anitaApi } from "../api/anitaApi";
import { useDevise } from "../contexts/DeviseContext";
import Money from "../components/Money";


ChartJS.register(
  ArcElement, 
  Tooltip, 
  Legend,  
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title);


const Dashboard = () => {
  const { convert, selectedDevise } = useDevise()
  const [commandes, setCommandes] = useState([])
  const [abonnements, setAbonnements] = useState([])
  const [annonces, setAnnonces] = useState([])
  const [providers, setProviders] = useState([])
  const [clients, setClients] = useState([])
  const [loading, setLoading] = useState(false)
  const [reportsData, setReportsData] = useState([])
  const [anitaTotalClics, setAnitaTotalClics] = useState(0)
  const [anitaStats, setAnitaStats] = useState([])
  const abortController = new AbortController()

  const navigate = useNavigate()

  // Etat des commandes
  const data = {
    labels: reportsData.orders_status?.map((stat) => stat.status),
    datasets: [
      {
        label: 'Commandes',
        data: reportsData.orders_status?.map((stat) => stat.total),
        backgroundColor: [
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(255, 99, 132, 0.2)',
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // Rapport annuel des commandes
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Chiffre d\'affaire par an',
      },
    },
  };
  const labels = reportsData.monthly_revenue?.map((stat) => stat.month);
  const data2 = {
  labels,
  datasets: [
    {
      label: `${reportsData.current_year}${selectedDevise ? ` (${selectedDevise.iso_code})` : ''}`,
      data: reportsData.monthly_revenue?.map((stat) => convert(stat.revenue)),
      borderColor: 'rgba(137, 18, 228, 1)',
      backgroundColor: 'rgba(152, 15, 220, 0.5)',
    },

  ],
};

  // Liste des clients
  const handlefetchdataClient = async () => {
    setLoading(true)

    try {
        const res = await ClientApi.getClients(abortController.signal)

        if (!res.success) {
          return Swal.fire({
            title:'Impossible d\'enregistrer',
            text:res.message,
            // timer:3000
          })
        }
        // if(!res){
        //     setLoading(false)
        //        return;

        // }            
        
        setClients(res.data)
        setLoading(false)
        console.log(clients)

     } catch (error) {
        const messages = await error.messages ?? error.message;

        return Swal.fire({
          title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
          text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
          icon:"error",
        }).then((result) => {
          Auth.removeSessionToken()
          return navigate(`/login`)			
        });
        

     }
}

  // Liste des prestataires
  const handlefetchdataPro = async () => {
    setLoading(true)

    try {
        const res = await providerApi.getProviders(abortController.signal)

        if(!res){
            setLoading(false)
               return;

        }            
        
        setProviders(res.data)
        setLoading(false)
        console.log(providers)

     } catch (error) {
         console.log(error)
        setLoading(false)

     }
}

  // Liste des commandes
  const handlefetchdataCommandes = async () => {
    setLoading(true)

    try {
        const res = await CommandeApi.getCommandes(abortController.signal)

        if(!res){
            setLoading(false)
               return;

        }

        setCommandes(res.data)
        setLoading(false)

     } catch (error) {
         console.log(error)
        setLoading(false)

     }
}

  // Liste des abonnements
  const handlefetchdataAbonnements = async () => {
    setLoading(true)

    try {
        const res = await AbonnementApi.getAbonnements(abortController.signal)

        if(!res){
            setLoading(false)
               return;

        }

        setAbonnements(res.data)
        setLoading(false)

     } catch (error) {
         console.log(error)
        setLoading(false)

     }
}

const handlefetchAnnonce = async () => {
  setLoading(true)

  try {
      const res = await annonceApi.getAnnouncements(abortController.signal)

      if(!res){
          setLoading(false)
             return;

      }            
      
      setAnnonces(res.data)
      setLoading(false)

   } catch (error) {
       console.log(error)
      setLoading(false)

   }
}

// Rapports
const handleFetchDataReports = async () => {
  setLoading(true)
  
  try {
    
    // const res = await AdminApi.getReports(JSON.stringify(payload),abortController.signal)
    const res = await AdminApi.getReports(abortController.signal);
    if(!res){
        setLoading(false)
        return;
    } 

      setReportsData(res.data)
      setLoading(false)
  } catch (error) {
    console.log(error)
    setLoading(false)
  }
}

  // Statistiques des clics sur Anita
  const handleFetchAnitaStats = async () => {
    try {
      const [totalRes, statsRes] = await Promise.all([
        anitaApi.getTotalClics(abortController.signal),
        anitaApi.getStatistiquesParDate(abortController.signal),
      ])
      setAnitaTotalClics(totalRes?.total_clics || 0)
      setAnitaStats(Array.isArray(statsRes) ? statsRes : [])
    } catch (error) {
      console.log(error)
    }
  }

  const anitaChartData = {
    labels: anitaStats.map((s) => s.date),
    datasets: [
      {
        label: 'Clics sur Anita',
        data: anitaStats.map((s) => s.nombre_clics),
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 0.5)',
      },
    ],
  }

  const anitaChartOptions = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: 'Nombre de clics par date' },
    },
    scales: {
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  }

  // Liste des utilisateurs

  useEffect(() => {
    handleFetchAnitaStats()
    handlefetchdataCommandes()
    handlefetchdataAbonnements()
    handlefetchdataPro()
    handlefetchdataClient()
    handlefetchAnnonce()
    handleFetchDataReports()
  },[])
  
  const handleYearChange = async (year) => {
    console.log(year)
    abortController.abort();
    const newAbortController = new AbortController();
    
    const res = await AdminApi.getReportsByYear(year,newAbortController.signal)
    const newData = res.data;
    setReportsData((prev) => ({
      ...prev,
      current_year: year,
      monthly_revenue: newData.monthly_revenue,
      total_orders: newData.total_orders,
    }));
  }

  // Abonnements dont le statut est actif et la date de fin n'est pas dépassée
  const activeAbonnementsCount = abonnements?.filter((a) => a.status === 'active' && new Date(a.end_date) >= new Date()).length || 0

  return (

    <MainLayout>
        <div className="container">
          <h2 className="text-2xl font-bold">Bienvenue dans l'Admin Dashboard</h2>
          <div className="grid gap-6 mt-6 md:grid-cols-2 lg:grid-cols-5">
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Statistiques Utilisateurs</h3>
              <p className="mt-2 text-gray-600">Nombre d'utilisateurs actifs : 102</p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Commandes</h3>
              <p className="mt-2 text-gray-600">{commandes?.length || 0}</p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Utilisateurs</h3>
              <p className="mt-2 text-gray-600">{providers?.length + clients?.length || 0}</p>
            </div>

            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Annonces</h3>
              <p className="mt-2 text-gray-600">{ annonces?.length || 0}</p>
            </div>

            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Abonnements actuels</h3>
              <p className="mt-2 text-gray-600">{activeAbonnementsCount}</p>
            </div>
          </div>
        </div>
        <div className="container mt-3">
          <h2 className="text-2xl font-bold mb-2">Rapports</h2>
          <div class="grid grid-cols-3 gap-4">
             <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Total des commissions</h3>
              <p className="mt-2 text-gray-600 text-xl bold"><Money amount={reportsData?.total_commissions || 0} /></p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Montant total des commandes validées</h3>
              <p className="mt-2 text-gray-600 text-xl bold"><Money amount={reportsData?.yearly_revenue || 0} /></p>
            </div>
          </div>
          
        </div>
        <div className="container mt-3">
          <div class="grid grid-cols-3 gap-4">             
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Etat des commandes</h3>
              
              <div>
                <Pie data={data} />
              </div>
            </div>
            <div class="col-span-2 p-4 bg-white rounded-lg shadow">
                <select
                  value={reportsData.current_year}
                  onChange={(e) => handleYearChange(e.target.value)}
                  className="text-dark text-sm rounded-md p-1 cursor-pointer border border-gray"
                >
                  {reportsData.years?.map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              <div>
                <Line options={options} data={data2} />
              </div>
            </div>
            
          </div>
        </div>
        <div className="container mt-3">
          <h2 className="text-2xl font-bold mb-2">Anita</h2>
          <div className="grid grid-cols-3 gap-4">
            <div className="p-4 bg-white rounded-lg shadow">
              <h3 className="text-lg font-semibold">Total des clics sur Anita</h3>
              <p className="mt-2 text-gray-600 text-xl bold">{anitaTotalClics}</p>
            </div>
            <div className="col-span-2 p-4 bg-white rounded-lg shadow">
              <Line options={anitaChartOptions} data={anitaChartData} />
            </div>
          </div>
        </div>


    </MainLayout>
  );
};

export default Dashboard;
